import React from 'react'

const Formfield = ({LabelName, placeholder,inputType,isTextArea,value,handleChange}) => {
  return (
    <label className='flex-1 w-full flex flex-col'>

        {LabelName && (
            <span className='font-suwannaphum font-medium text-[14px] leading-[22px] text-[#808191] mb-[10px]'>{LabelName}</span>)}
            {isTextArea?(
                <textarea
                    required
                    value={value}
                    onChange={handleChange}
                    rows={10}
                    placeholder={placeholder}
                    className='py-[15px] sm:px-[25px] px-[15px] outline-none border-[1px] sm:min-w-[300px]
                    text-black text-[15px] placeholder:text-[#4b5265] rounded-[10px] bg-transparent font-suwannaphum border-[#3a3a43]'
                />
            ):(
                <input 
                    required
                    value={value}
                    onChange={handleChange}
                    type={inputType}
                    placeholder={placeholder}
                    className='w-full px-4 py-4 border border-black-600 rounded outline-none text-base border-l-0 border-r-0 border-t-0 border-b border-black'
                />
            )}
    </label>
  )
}

export default Formfield